/**
 * Rate-table text-format schema, extracted from format-rate-table-display-text
 * so schema consumers don't drag the carrier label/data universe.
 */
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum DeliveryDateFormatStrategy {
  LOCALE_STRING_CUSTOM = "LOCALE_STRING_CUSTOM",
}

export const deliveryDateFormatWeekdayOptions = [
  "short",
  "long",
  "narrow",
] as const;
export const deliveryDateFormatMonthOptions = [
  "short",
  "long",
  "narrow",
  "numeric",
  "2-digit",
] as const;
export const deliveryDateFormatDayOptions = ["numeric", "2-digit"] as const;
export const deliveryDateFormatYearOptions = ["numeric", "2-digit"] as const;
export const deliveryDateRangeSchema = z.object({
  startRelativeToDeliveryDate: z.number().int(),
  endRelativeToDeliveryDate: z.number().int(),
});
export type DeliveryDateRange = z.infer<typeof deliveryDateRangeSchema>;

/** Extracted so a surface can override only the date rendering, not the range. */
export const deliveryDateFormatSchema = z.union([
  z.object({
    strategy: z.literal(DeliveryDateFormatStrategy.LOCALE_STRING_CUSTOM),
    weekday: createEnum(deliveryDateFormatWeekdayOptions, {
      enumName: "DeliveryDateFormatWeekdayOptions",
    }).optional(),
    month: createEnum(deliveryDateFormatMonthOptions, {
      enumName: "DeliveryDateFormatMonthOptions",
    }).optional(),
    day: createEnum(deliveryDateFormatDayOptions, {
      enumName: "DeliveryDateFormatDayOptions",
    }).optional(),
    /** Omitted by default: a same-year estimate reads better without it. */
    year: createEnum(deliveryDateFormatYearOptions, {
      enumName: "DeliveryDateFormatYearOptions",
    }).optional(),
  }),
]);
export type DeliveryDateFormat = z.infer<typeof deliveryDateFormatSchema>;

export const rateTableTextFormatSchema = z.object({
  deliveryDateFormat: deliveryDateFormatSchema.optional(),
  range: deliveryDateRangeSchema.optional(),
});
export type RateTableTextFormat = z.infer<typeof rateTableTextFormatSchema>;
